import { render } from "./Wrapper.vue?vue&type=template&id=282081b8"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=282081b8&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__